import { useEffect, useState } from "react";
import { api } from "./api";

/** SATU sumber daftar cabang untuk semua dropdown.
 *
 * Dulu 12 halaman memegang salinan hardcode
 * ["ZOA GROUP","BEBE","ZONA","UP.Gadget","UPPLESORIES"] masing-masing —
 * cabang baru yang dibuat owner di Master Data > Cabang tidak pernah muncul
 * di form mana pun. Sekarang semuanya membaca GET /inventory/cabang-options
 * (gabungan master cabang HRIS + cabang karyawan + cabang gudang, ejaan
 * di-dedup case-insensitive di backend, cukup login tanpa izin khusus).
 *
 * `untuk: "nota"` (brief 22 Sep D9) membaca `?untuk=nota`: HANYA cabang yang
 * punya Kas Toko + akun penampung trade-in — daftar yang SAMA dengan yang
 * ditegakkan server saat nota disimpan (`branches_master.pastikan_cabang_nota`),
 * jadi dropdown nota tidak menawarkan cabang yang ujungnya ditolak 400.
 */
// Fallback saat permintaan GAGAL = KOSONG (brief 22 Sep D9 — keputusan 23 Sep:
// "nama toko bawaan ZOA dibuang").
//
// Sampai 23 Sep 2026 daftar ini berisi lima nama toko ZOA ("ZOA GROUP",
// "Bebefone", "Zona Gadget", "UP.Gadget", "Upplesories"). EppleHub dijual
// white-label: begitu `/inventory/cabang-options` gagal dimuat sekali saja,
// pembeli produk ini disodori nama toko ORANG LAIN — dan di form nota, cabang
// yang tidak punya Kas Toko + penampung ditolak server atau (sebelum D9) uangnya
// mendarat di kas bawaan/kliring. Daftar kosong jujur: pengguna melihat tidak ada
// pilihan, dan permintaannya diulang di mount berikutnya (respons gagal tidak
// di-cache). Dijaga `backend/tests/test_kosakata_cabang_konsisten.py`.
const FALLBACK = [];

const _cache = {};      // kunci = nilai `untuk` ("" = daftar umum)
const _inflight = {};

export function ambilCabangOptions(untuk = "") {
  const kunci = untuk || "";
  if (_cache[kunci]) return Promise.resolve(_cache[kunci]);
  if (!_inflight[kunci]) {
    _inflight[kunci] = api.get("/inventory/cabang-options", { params: kunci ? { untuk: kunci } : undefined })
      .then(r => {
        const items = (r.data?.items || []).filter(Boolean);
        if (items.length) _cache[kunci] = items;   // jangan cache respons kosong
        return _cache[kunci] || FALLBACK;
      })
      .catch(() => FALLBACK)                        // gagal = kosong, TANPA cache (retry di mount berikutnya)
      .finally(() => { _inflight[kunci] = null; });
  }
  return _inflight[kunci];
}

/** Hook dropdown cabang. `denganKosong` menambah opsi "" di depan (untuk
 *  filter "semua cabang" — pola daftar lama yang berawalan ""). `untuk: "nota"`
 *  = hanya cabang sah untuk nota penjualan (lihat catatan berkas ini). */
export function useCabangOptions({ denganKosong = false, untuk = "" } = {}) {
  const [opsi, setOpsi] = useState(_cache[untuk || ""] || FALLBACK);
  useEffect(() => {
    let hidup = true;
    ambilCabangOptions(untuk).then(o => { if (hidup) setOpsi(o); });
    return () => { hidup = false; };
  }, [untuk]);
  return denganKosong ? ["", ...opsi] : opsi;
}
